import { NavLink, Navigate, Outlet } from "react-router-dom";

import { Dropdown, ForbiddenState, StateMessage } from "@/ds";
import { TelaComAbas } from "@/shared/components/tela-com-abas";
import {
  FINANCEIRO_CARREGANDO_LABEL,
  FINANCEIRO_SEM_PERMISSAO_DESCRIPTION,
} from "./financeiro-configuracoes.constants";
import styles from "./financeiro-configuracoes.module.scss";
import type { FinanceiroConfiguracoesViewModel } from "./types-financeiro-configuracoes";

export function FinanceiroConfiguracoesView({
  titulo,
  abas,
  abasLabel,
  mobileQuery,
  subAbas,
  subAbasLabel,
  subAbasMobile,
  subAbaAtiva,
  irParaSubAba,
  conteudo,
  redirecionarPara,
}: FinanceiroConfiguracoesViewModel) {
  return (
    <TelaComAbas
      titulo={titulo}
      abas={abas}
      abasLabel={abasLabel}
      mobileQuery={mobileQuery}
      variante="janela"
      testId="financeiro-screen"
      headerTestId="financeiro-header"
    >
      {subAbas.length > 0 && subAbasMobile ? (
        <div className={styles.subAbasSeletor} data-testid="financeiro-subabas">
          <Dropdown
            options={subAbas.map(({ label, to }) => ({ label, value: to }))}
            value={subAbaAtiva}
            onChange={(evento) => irParaSubAba(evento.value)}
            showClear={false}
            ariaLabel={subAbasLabel}
            data-testid="financeiro-subabas-seletor"
          />
        </div>
      ) : null}
      {subAbas.length > 0 && !subAbasMobile ? (
        <nav className={styles.subAbas} aria-label={subAbasLabel} data-testid="financeiro-subabas">
          {subAbas.map((subAba) => (
            <NavLink
              key={subAba.to}
              to={subAba.to}
              className={({ isActive }) => (isActive ? styles.subAbaAtiva : styles.subAba)}
            >
              {subAba.label}
            </NavLink>
          ))}
        </nav>
      ) : null}

      {conteudo === "carregando" ? (
        <StateMessage
          variant="loading"
          title={FINANCEIRO_CARREGANDO_LABEL}
          testId="financeiro-loading"
        />
      ) : null}
      {conteudo === "sem-permissao" ? (
        <ForbiddenState
          description={FINANCEIRO_SEM_PERMISSAO_DESCRIPTION}
          testId="financeiro-sem-permissao"
        />
      ) : null}
      {conteudo === "redirecionar" && redirecionarPara ? (
        <Navigate to={redirecionarPara} replace />
      ) : null}
      {conteudo === "rota" ? <Outlet /> : null}
    </TelaComAbas>
  );
}
